import { Sprout } from "lucide-react";
import { useSettings } from "@/context/SettingsContext";

export const Logo = ({ light = false, size = "md" }) => {
  const { appName, logoUrl } = useSettings();
  const box = size === "lg" ? "h-14 w-14" : "h-11 w-11";
  return (
    <div className="flex items-center gap-3" data-testid="app-logo">
      <div className={`${box} shrink-0 rounded-2xl overflow-hidden flex items-center justify-center ${logoUrl ? "bg-white" : "bg-[#C86D51]"}`}>
        {logoUrl ? (
          <img src={logoUrl} alt={appName} className="h-full w-full object-contain p-1" data-testid="app-logo-image" />
        ) : (
          <Sprout className="h-6 w-6 text-white" data-testid="app-logo-placeholder" />
        )}
      </div>
      <div className="leading-tight">
        <p className={`font-display font-extrabold text-lg tracking-tight ${light ? "text-white" : "text-[#1B2A26]"}`}>{appName}</p>
        <p className={`text-xs font-semibold tracking-wide ${light ? "text-white/70" : "text-[#5C6B66]"}`}>TECNOLOGIA AGRÍCOLA</p>
      </div>
    </div>
  );
};
